import type { ProjectId } from 'owa-timestream-types';
import type { BoardEditorLoadState } from './schema';
import getStore from './store';

export function isBoardEditorOpen(): boolean {
    return getStore().isOpen;
}

export function isEditingProject(): boolean {
    return !!getStore().projectId;
}

export function getProjectId(): ProjectId | undefined {
    return getStore().projectId;
}

export function getName(): string {
    return getStore().name;
}

export function getLoadState(): BoardEditorLoadState {
    return getStore().loadState;
}
